import fetch from '@ixigo/fetch';
export interface Whybook {
	src: string;
	alt?: string;
}

interface WhyBookResponse {
	data: Whybook[];
}

export const fetchWhyBook = async () => {
	try {
		const res = await fetch
			.get<WhyBookResponse>('growth/api/v1/features?product=CABS&type=WHY_BOOK')
			.json();
		return res;
	} catch {
		return null;
	}
};
